import { render } from "./kyc_info.vue?vue&type=template&id=66534d52"
import script from "./kyc_info.vue?vue&type=script&lang=js"
export * from "./kyc_info.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__